(function () {
  'use strict';

  // ---- Shared helpers ----------------------------------------

  function getHeader() {
    return document.getElementById('ShackletonsHeader');
  }

  function updateHeaderHeight() {
    var header = getHeader();
    if (header) {
      document.documentElement.style.setProperty(
        '--shack-header-height',
        header.getBoundingClientRect().bottom + 'px'
      );
    }
  }

  function updateMainContentMargin() {
    var mainContent = document.getElementById('MainContent');
    if (!mainContent) return;
    var header = getHeader();
    var announcementBar = document.querySelector('.announcement-bar-section');
    var headerHeight = header ? header.getBoundingClientRect().height : 0;
    var announcementHeight = 0;
    mainContent.style.marginTop = (headerHeight + announcementHeight) + 'px';
  }

  // ---- Sticky header -----------------------------------------

  function initStickyHeader() {
    var header = getHeader();
    if (!header) return;

    var type = header.dataset.stickyType || 'on-scroll-up';
    if (type === 'none') return;

    var currentScrollTop = 0;
    var headerInitialBottom = 0;

    function setInitialBottom() {
      headerInitialBottom = header.getBoundingClientRect().bottom + window.pageYOffset;
    }

    updateHeaderHeight();
    setInitialBottom();

    window.addEventListener('resize', function () {
      updateHeaderHeight();
      updateMainContentMargin();
    }, { passive: true });

    window.addEventListener('scroll', function () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (type === 'always') {
        header.classList.add('shack-header--sticky');
        currentScrollTop = scrollTop;
        return;
      }

      // Keep visible when a mega panel is open
      if (header.querySelector('.shack-header__nav-item--is-open')) {
        header.classList.add('shack-header--sticky');
        header.classList.remove('shack-header--hidden');
        currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > currentScrollTop && scrollTop > headerInitialBottom) {
        header.classList.add('shack-header--sticky', 'shack-header--hidden');
        closeAllPanels();
      } else if (scrollTop < currentScrollTop) {
        header.classList.add('shack-header--sticky');
        header.classList.remove('shack-header--hidden');
      }

      currentScrollTop = scrollTop;
    }, { passive: true });
  }

  // ---- Mega menu ---------------------------------------------

  function openPanel(item) {
    closeAllPanels();
    item.classList.add('shack-header__nav-item--is-open');
    var btn = item.querySelector('.shack-header__nav-link');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    updateHeaderHeight();
  }

  function closePanel(item) {
    item.classList.remove('shack-header__nav-item--is-open');
    var btn = item.querySelector('.shack-header__nav-link');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  function closeAllPanels() {
    document.querySelectorAll('.shack-header__nav-item--is-open').forEach(closePanel);
  }

  function switchTab(item, tabId) {
    item.querySelectorAll('.shack-tab-panel').forEach(function (p) {
      p.classList.remove('is-active');
    });
    item.querySelectorAll('[data-tab]').forEach(function (l) {
      l.classList.remove('shack-mega-panel__cat-link--active');
      l.setAttribute('aria-selected', 'false');
    });
    var panel = item.querySelector('#ShackTab-' + tabId);
    var link = item.querySelector('[data-tab="' + tabId + '"]');
    if (panel) panel.classList.add('is-active');
    if (link) {
      link.classList.add('shack-mega-panel__cat-link--active');
      link.setAttribute('aria-selected', 'true');
    }
  }

  function initMegaMenus() {
    document.querySelectorAll('.shack-header__nav-item').forEach(function (item) {
      if (!item.querySelector('.shack-mega-panel__dropdown')) return;

      var closeTimer = null;

      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        openPanel(item);
      });

      item.addEventListener('mouseleave', function () {
        if (window.Shopify && window.Shopify.designMode) return;
        closeTimer = setTimeout(function () { closePanel(item); }, 120);
      });

      item.addEventListener('keyup', function (e) {
        if (e.key === 'Escape') closePanel(item);
      });

      // Button click toggles (keyboard / touch fallback)
      var btn = item.querySelector('.shack-header__nav-link');
      if (btn) {
        btn.addEventListener('click', function () {
          if (item.classList.contains('shack-header__nav-item--is-open')) {
            closePanel(item);
          } else {
            openPanel(item);
          }
        });
      }

      // Tab switching on category link hover
      item.addEventListener('mouseover', function (e) {
        var tabLink = e.target.closest('[data-tab]');
        if (tabLink) switchTab(item, tabLink.dataset.tab);
      });
    });

    // Close when clicking outside
    document.addEventListener('click', function (e) {
      if (window.Shopify && window.Shopify.designMode) return;
      if (!e.target.closest('.shack-header__nav-item')) closeAllPanels();
    });
  }

  // ---- Mobile drawer -----------------------------------------

  function initDrawer() {
    var toggle = document.getElementById('ShackMenuToggle');
    var drawer = document.getElementById('ShackDrawer');
    var overlay = document.getElementById('ShackDrawerOverlay');
    if (!toggle || !drawer) return;

    var closeBtn = drawer.querySelector('.shack-drawer__close');

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      // Close any open sub panels
      drawer.querySelectorAll('.shack-drawer__panel--sub.is-open').forEach(function (p) {
        p.classList.remove('is-open');
      });
    }

    toggle.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    // Open sub panels
    drawer.querySelectorAll('.shack-drawer__item-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var targetId = btn.getAttribute('aria-controls');
        var sub = targetId ? document.getElementById(targetId) : null;
        if (sub) sub.classList.add('is-open');
      });
    });

    // Back button closes sub panel
    drawer.querySelectorAll('.shack-drawer__back').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sub = btn.closest('.shack-drawer__panel--sub');
        if (sub) sub.classList.remove('is-open');
      });
    });

    // Escape key
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  // ---- Theme editor support ----------------------------------

  function initThemeEditorSupport() {
    document.addEventListener('shopify:block:select', function (e) {
      var blockId = e.detail.blockId;

      // nav_item block → open its mega panel
      var panelEl = document.getElementById('ShackPanel-' + blockId);
      if (panelEl) {
        var navItem = panelEl.closest('.shack-header__nav-item');
        if (navItem) openPanel(navItem);
        return;
      }

      // category_link block → open parent panel + switch to its tab
      var tabEl = document.getElementById('ShackTab-' + blockId);
      if (tabEl) {
        var navItem = tabEl.closest('.shack-header__nav-item');
        if (navItem) { openPanel(navItem); switchTab(navItem, blockId); }
        return;
      }

      // panel block — shopify_attributes renders as data-shopify-editor-block='{"componentId":"<id>"}'
      var blockEl = document.querySelector('[data-shopify-editor-block*="' + blockId + '"]');
      if (!blockEl) return;
      var navItem = blockEl.closest('.shack-header__nav-item');
      if (!navItem) return;
      openPanel(navItem);
      var tabPanel = blockEl.closest('.shack-tab-panel');
      if (tabPanel) switchTab(navItem, tabPanel.id.replace('ShackTab-', ''));
    });

    document.addEventListener('shopify:block:deselect', closeAllPanels);
    document.addEventListener('shopify:section:deselect', closeAllPanels);

    // Re-init after section hot-reload in editor
    document.addEventListener('shopify:section:load', function () {
      initMegaMenus();
      initDrawer();
      initSearch();
    });
  }

  // ---- Search modal ------------------------------------------

  function initSearch() {
    var details = document.querySelector('#ShackletonsHeader .header__search details');
    if (!details) return;

    function closeSearch() {
      details.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
    }

    var closeBtn = details.querySelector('.search-modal__close-button');
    var overlay = details.querySelector('.modal-overlay');
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);
    if (overlay) overlay.addEventListener('click', closeSearch);
  }

  // ---- Init --------------------------------------------------

  function init() {
    initStickyHeader();
    initMegaMenus();
    initDrawer();
    initSearch();
    updateMainContentMargin();
    if (window.Shopify && window.Shopify.designMode) {
      initThemeEditorSupport();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
